import { ReportTimeServedService } from "@/services";

const Types = {
  SET_ERROR: "SET_ERROR",
  SET_LOADING: "SET_LOADING",
};

const state = {
  error: null,
  loading: false,
};

const getters = {
  error(state) {
    return state.error;
  },
  loading(state) {
    return state.loading;
  },
};

const mutations = {
  [Types.SET_LOADING]: (state, payload) => (state.loading = payload),
  [Types.SET_ERROR]: (state, payload) => (state.error = payload),
};

const actions = {
  async exportExcel({ commit }, payload) {
    commit(Types.SET_LOADING, true);
    try {
      const response = await ReportTimeServedService.exportExcel(payload);
      return response;
    } catch (err) {
      commit(Types.SET_LOADING, false);
      commit(Types.ERROR_SERVICE, err);
    }
    commit(Types.SET_LOADING, false);
  },
  async exportPdf({ commit }, payload) {
    commit(Types.SET_LOADING, true);
    try {
      const response = await ReportTimeServedService.exportPdf(payload);
      return response;
    } catch (err) {
      commit(Types.SET_LOADING, false);
      commit(Types.ERROR_SERVICE, err);
    }
    commit(Types.SET_LOADING, false);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
